import { render, staticRenderFns } from "./KeyboardShortcutsSidebar.vue?vue&type=template&id=e91f2efe&scoped=true"
import script from "./KeyboardShortcutsSidebar.vue?vue&type=script&lang=js"
export * from "./KeyboardShortcutsSidebar.vue?vue&type=script&lang=js"
import style0 from "./KeyboardShortcutsSidebar.vue?vue&type=style&index=0&id=e91f2efe&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e91f2efe",
  null
  
)

export default component.exports